import { ExtendedNumberBox } from './ExtendedNumberBox';

export default ExtendedNumberBox;
